import AltInstance from '../../../Common/Globals/Scripts/AltInstance';
import ActionHelper from '../../../Common/Actions/ActionHelper';
import ResetPasswordApi from '../Apis/ResetPasswordApi';
import NotificationActions from '../../../Common/Actions/NotificationActions';

class ResetPasswordActions {
    constructor() {
    }

    async resetPassword(password, userName, code) {
        try {
            await ActionHelper.executeRequest(() => ResetPasswordApi.resetPassword(userName, code, password));
        } catch(e) {
            return false;
        }

        NotificationActions.notificationReceived({
            icon: 'check',
            severity: 'success',
            title: 'Password reset successful',
            messages: ['Please wait while we redirect you to the login page or click the return to login link below the reset password button to proceed immediately.']
        });

        return true;
    }
}

export default AltInstance.createActions(ResetPasswordActions);
